module.exports = __webpack_public_path__ + "files/9811edadf0488ce1fffb4cc0653345b9.png";